module.exports = __webpack_public_path__ + "img/play_test.5b55cc4e.png";